import { get, post, patch } from 'services/http';

const shareAnswer = (partialAnswerId, visualizationType, visualizationOptions) =>
  post(
    '/answers/shared',
    {
      partialAnswerId,
      visualizationType,
      visualizationOptions
    },
    { addKgId: true }
  );

const uploadSharingPreview = (sharedAnswerId, image) =>
  patch(
    `/answers/shared/${sharedAnswerId}/image`,
    {
      base64Image: image
    },
    null,
    { addKgId: true }
  );

const getSharedAnswer = sharedAnswerId =>
  get(`/answers/shared/${sharedAnswerId}`, { addKgId: true, addSessionId: true });

export default {
  shareAnswer,
  getSharedAnswer,
  uploadSharingPreview
};
